"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebRTCConnectionsHost = void 0;
const LinkupAddress_1 = require("../../linkup/LinkupAddress");
const LinkupManager_1 = require("../../linkup/LinkupManager");
const WebRTCConnection_1 = require("../WebRTCConnection");
class WebRTCConnectionsHost {
    constructor(eventCallback, linkup) {
        this.connections = new Map();
        this.linkup = linkup || new LinkupManager_1.LinkupManager();
        this.eventCallback = eventCallback;
        this.messageCallback = (data, conn) => {
            let ev = {
                type: 'message-received',
                connId: conn.getConnectionId(),
                data: data
            };
            this.eventCallback(ev);
        };
        this.connectionReadyCallback = (conn) => {
            let ev = {
                type: 'connection-ready',
                connId: conn.getConnectionId()
            };
            this.eventCallback(ev);
        };
        this.connectionStatusChangeCallback = (status, conn) => {
            let ev = {
                type: 'connection-status-change',
                connId: conn.getConnectionId(),
                status: status
            };
            this.eventCallback(ev);
        };
        this.emptyBufferCallback = (conn) => {
            let ev = {
                type: 'update-buffered-amount',
                connId: conn.getConnectionId(),
                bufferedAmount: conn.bufferedAmount()
            };
            this.eventCallback(ev);
        };
    }
    static isEvent(msg) {
        const type = msg === null || msg === void 0 ? void 0 : msg.type;
        return (type === 'connection-ready' ||
            type === 'connection-status-change' ||
            type === 'message-received' ||
            type === 'update-buffered-amount');
    }
    static isCommand(msg) {
        const type = msg === null || msg === void 0 ? void 0 : msg.type;
        return (type === 'create-connection' ||
            type === 'message-callback-set' ||
            type === 'open-connection' ||
            type === 'answer-connection' ||
            type === 'receive-signalling' ||
            type === 'close-connection' ||
            type === 'send-message');
    }
    execute(cmd) {
        var _a, _b, _c, _d, _e;
        if (cmd.type === 'create-connection') {
            const create = cmd;
            const local = LinkupAddress_1.LinkupAddress.fromURL(create.localEndpoint);
            const remote = LinkupAddress_1.LinkupAddress.fromURL(create.remoteEndpoint);
            const callId = create.connId;
            if (!this.connections.has(callId)) {
                const conn = new WebRTCConnection_1.WebRTCConnection(this.linkup, local, remote, callId, this.connectionReadyCallback, this.connectionStatusChangeCallback);
                this.connections.set(callId, conn);
            }
        }
        else if (cmd.type === 'message-callback-set') {
            (_a = this.connections.get(cmd.connId)) === null || _a === void 0 ? void 0 : _a.setMessageCallback(this.messageCallback);
        }
        else if (cmd.type === 'open-connection') {
            (_b = this.connections.get(cmd.connId)) === null || _b === void 0 ? void 0 : _b.open(cmd.channelName);
        }
        else if (cmd.type === 'answer-connection') {
            (_c = this.connections.get(cmd.connId)) === null || _c === void 0 ? void 0 : _c.answer(cmd.message);
        }
        else if (cmd.type === 'receive-signalling') {
            (_d = this.connections.get(cmd.connId)) === null || _d === void 0 ? void 0 : _d.receiveSignallingMessage(cmd.message);
        }
        else if (cmd.type === 'close-connection') {
            (_e = this.connections.get(cmd.connId)) === null || _e === void 0 ? void 0 : _e.close();
            this.connections.delete(cmd.connId);
        }
        else if (cmd.type === 'send-message') {
            if (!this.connections.has(cmd.connId)) {
                console.log('WARNING: trying to send message on ' + cmd.connId + ', but there is no such connection.');
            }
            const conn = this.connections.get(cmd.connId);
            if (conn !== undefined) {
                conn.send(cmd.contents);
                const ev = {
                    type: 'update-buffered-amount',
                    connId: cmd.connId,
                    bufferedAmount: conn.bufferedAmount()
                };
                this.eventCallback(ev);
            }
        }
    }
}
exports.WebRTCConnectionsHost = WebRTCConnectionsHost;
//# sourceMappingURL=WebRTCConnectionsHost.js.map